import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconGear = props => (
  <SvgIcon {...props} viewBox="0 0 19.454 20">
    <path fillRule="evenodd" d="m17.159 10.98c0.04-0.32 0.07-0.64 0.07-0.98s-0.03-0.66-0.07-0.98l2.11-1.65c0.19-0.15 0.24-0.42 0.12-0.64l-2-3.46c-0.12-0.22-0.39-0.3-0.61-0.22l-2.49 1c-0.52-0.4-1.08-0.73-1.69-0.98l-0.38-2.65c-0.03-0.24-0.24-0.42-0.49-0.42h-3.9997c-0.25 0-0.46 0.18-0.49 0.42l-0.38 2.65c-0.61 0.25-1.17 0.59-1.69 0.98l-2.49-1c-0.23-0.09-0.49 0-0.61 0.22l-2 3.46c-0.12997 0.22-0.069968 0.49 0.12003 0.64l2.11 1.65c-0.04 0.32-0.07 0.65-0.07 0.98s0.03 0.66 0.07 0.98l-2.11 1.65c-0.19 0.15-0.24 0.42-0.12 0.64l2 3.46c0.12 0.22 0.39 0.3 0.61 0.22l2.49-1c0.52 0.4 1.08 0.73 1.69 0.98l0.38 2.65c0.03 0.24 0.24 0.42 0.49 0.42h4c0.25 0 0.46-0.18 0.49-0.42l0.38-2.65c0.61-0.25 1.17-0.59 1.69-0.98l2.49 1c0.23 0.09 0.49 0 0.61-0.22l2-3.46c0.12-0.22 0.07-0.49-0.12-0.64l-2.11-1.65zm-7.4298 2.52c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z" />
  </SvgIcon>
);

export default IconGear;



// WEBPACK FOOTER //
// ./src/components/icons/IconGear.js